export default {
    inject: ['EventBus'],
    render(h) {
        const container = h(
            'span', {
            }
        );

        return container;
    },
    props: {
    },
    mounted() {
        this.EventBus.$on('stepShown', (inputs) => {
            this.$nextTick(() => {
                if(inputs.length) {
                    for (var i = 0; i < inputs.length; i++) {
                        if(inputs[i].checked) {
                            this.$el.innerHTML = inputs[i].value;
                            break;
                        }
                    }
                } else {
                    this.$el.innerHTML = inputs.value;
                }
            });
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-transition-input-value.js